/** Builds a public agency path for platform-hosted and custom-domain sites. */
export function publicSitePath(agencyId: string, suffix = "", customDomain?: string) {
  const normalizedSuffix = suffix ? (suffix.startsWith("/") ? suffix : `/${suffix}`) : "";
  return `${customDomain?.trim() ? "" : `/site/${agencyId}`}${normalizedSuffix}` || "/";
}

/** Keeps editor-controlled links navigable without allowing script schemes. */
export function publicHref(value: unknown, fallback = "#") {
  if (typeof value !== "string") return fallback;
  const href = value.trim();
  if (!href) return fallback;
  if (href.startsWith("#") || (href.startsWith("/") && !/^\/[\\/]/.test(href)) || href.startsWith("./") || href.startsWith("../") || href.startsWith("?")) return href;
  if (/^(https?:|mailto:|tel:)/i.test(href)) return href;
  return fallback;
}
